export enum WebDocumentRoutes {
  BasePrefix = "web-documents",
  Search = "search",
  ById = ":webDocumentId",
  Reload = "reload",
}
